export enum OptionsFilterEnum {
  query = "query",
  "custom.customer.name" = "custom.customer.name",
  "custom.customer.id" = "custom.customer.id",
  "source.name" = "source.name",
  "source.items.custom.series" = "source.items.custom.series",
  "custom.contenedorPadre" = "custom.contenedorPadre"
}
